import { ref } from 'vue'

// Global state for create project modal
const isCreateProjectModalOpen = ref(false)

export function useCreateProjectModal() {
  const openCreateProjectModal = () => {
    isCreateProjectModalOpen.value = true
  }

  const closeCreateProjectModal = () => {
    isCreateProjectModalOpen.value = false
  }

  return {
    isCreateProjectModalOpen,
    openCreateProjectModal,
    closeCreateProjectModal,
  }
}
